import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setWorkflowName,
  setWorkflowDescription,
  setWorkflowRerunFlag,
} from "ReduxStore/Slices/workflowSlice";
import { get_workflow_data } from "components/Workflow_Components/Api";

export default function AutomationInfo() {
  const automationNameRef = useRef();
  const automationDescriptionRef = useRef();
  const automationRerunRef = useRef();
  const dispatch = useDispatch();
  const workflowData = useSelector((state) => state.workflowSetter);

  useEffect(() => {
    automationNameRef.current.value = workflowData.workflowName;
    automationDescriptionRef.current.value = workflowData.workflowDescription;
    automationRerunRef.current.checked = workflowData.workflowRerunFlag;
  }, [workflowData]);

  return (
    <>
      <div
        className="inputOuter"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <div>
          <label className="large">Automation Name </label>
          <input
            id="audienceName"
            type="text"
            className="kwDesign max351"
            required
            onChange={(event) => dispatch(setWorkflowName(event.target.value))}
            ref={automationNameRef}
          />
        </div>
      </div>
      <div
        className="inputOuter"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <input
            id="audienceName"
            type="checkbox"
            onChange={(event) =>
              dispatch(setWorkflowRerunFlag(event.target.checked))
            }
            ref={automationRerunRef}
          />

          <label className="large" style={{ margin: "1vh" }}>
            Rerun on trigger{" "}
          </label>
        </div>
        <p className="medium">
          If you check this, the automation will rerun for each triggering event
          for the same user account.{" "}
        </p>
      </div>
      <div className="inputOuter">
        <label className="large">Description</label>
        <textarea
          id="textArea"
          className="csTextarea"
          required
          onChange={(event) =>
            dispatch(setWorkflowDescription(event.target.value))
          }
          ref={automationDescriptionRef}
        ></textarea>
      </div>
    </>
  );
}
